import { monthDaysTitle, weekDaysTitle } from '@/modules/auto-invest/constants';
import { IAutoInvestSchedule } from '@/services/apis/paymentService/types';

export const getScheduleDaysTitle = (
  scheduleType: string,
  scheduleDay: number
): string => {
  if (scheduleType === 'Weekly') {
    return weekDaysTitle[scheduleDay];
  } else if (scheduleType === 'Monthly') {
    return monthDaysTitle[scheduleDay];
  }
  return '';
};

export const getSchedulesDescription = (
  SchedulesList: IAutoInvestSchedule[]
): string => {
  if (!SchedulesList || !SchedulesList?.length) {
    return '-';
  }

  let scheduleDescriptionSuffix = '';

  const scheduleDaysTitle: string[] = [];

  for (const { scheduleDay, scheduleType } of SchedulesList) {
    if (scheduleType === 'ProfitHami' && !scheduleDescriptionSuffix) {
      scheduleDescriptionSuffix = 'ماهانه';
      break;
    }
    if (scheduleType === 'Daily' && !scheduleDescriptionSuffix) {
      scheduleDescriptionSuffix = 'روزانه';
      break;
    }
    if (scheduleType === 'Weekly' || scheduleType === 'Monthly') {
      const daysTitle = getScheduleDaysTitle(scheduleType, scheduleDay);

      scheduleDaysTitle.push(daysTitle);
      if (!scheduleDescriptionSuffix) {
        scheduleDescriptionSuffix =
          scheduleType === 'Weekly' ? ' هر هفته' : ' هر ماه';
      }
    }
  }

  const scheduleDescription = scheduleDaysTitle.join(' و ');

  return scheduleDescription + scheduleDescriptionSuffix;
};
